import {ConfigProvider, Divider, Drawer, Menu} from 'antd';
import PropTypes from 'prop-types';
import {AiOutlineClose, AiOutlineHome} from 'react-icons/ai';
import {GiHeartNecklace} from 'react-icons/gi';
import {GrGallery} from 'react-icons/gr';
import {IoIosArrowForward} from 'react-icons/io';
import {MdOutlineShoppingCart} from 'react-icons/md';
import {RiAccountBoxLine, RiContactsBook3Line} from 'react-icons/ri';
import {useSelector} from 'react-redux';
import {Link} from 'react-router-dom';

const DrawerComponent = ({open, closeDrawer}) => {
  const {loggedIn} = useSelector(state => state.auth);
  
  const menuItems = [
    {name: 'Home', path: '/', icon: <AiOutlineHome />},
    {name: 'About', path: '/about', icon: <RiContactsBook3Line />},
    {name: 'Product', path: '/product', icon: <GiHeartNecklace />},
    {name: 'Gallery', path: '/gallery', icon: <GrGallery />},
    {name: 'Cart', path: '/cart', icon: <MdOutlineShoppingCart />},
    loggedIn ? 
      {name: 'Profile', path: '/userhistory', icon: <RiAccountBoxLine />} : 
      {name: 'Login', path: '/auth/login', icon: <RiAccountBoxLine />},
  ];
  
  return (
    <ConfigProvider theme={{token: {colorPrimary: '#ffffff', colorText: '#ffffff'}}}>
      <Drawer
        title={'Menu'}
        placement={'right'}
        onClose={closeDrawer}
        open={open}
        bodyStyle={{
          padding: 10,
          backgroundColor: '#3D180F',
          boxShadow: '0 4px 12px rgba(255, 255, 255, 0.1)',
          borderLeft: '1px solid #444444',
        }}
        headerStyle={{
          backgroundColor: '#3D180F',
          borderBottom: '1px solid #63463F',
          boxShadow: '0 2px 6px rgba(255, 255, 255, 0.1)',
        }}
        width={300}
        closeIcon={<AiOutlineClose className={'text-white text-xl'} />}
      >
        <div className={'-m-[3px]'}>
          <Menu mode={'vertical'} selectedKeys={[]} className={'text-center'} style={{borderInlineEnd: 'none', padding: 0, background: 'transparent'}}>
            {menuItems.map((item, index) => (
              <div key={index}>
                <Menu.Item>
                  <Link
                    to={item.path}
                    onClick={closeDrawer}
                    className={'text-white cursor-pointer text-base'}
                  >
                    <div className={'flex flex-row justify-between items-center'}>
                      <div className={'flex flex-row items-center'}>
                        <span className={'text-lg mr-1 ml-3'}>{item.icon}</span>
                        <span className={'text-lg'}>{item.name}</span>
                      </div>
                      <div>
                        <IoIosArrowForward />
                      </div>
                    </div>
                  </Link>
                </Menu.Item>
                {index !== menuItems.length - 1 && <Divider className={'my-1 h-[0.2px] bg-[#63463F]'} />}
              </div>
            ))}
          </Menu>
        </div>
      </Drawer>
    </ConfigProvider>
  );
};

DrawerComponent.propTypes = {
  open: PropTypes.bool.isRequired,
  closeDrawer: PropTypes.func.isRequired,
};

export default DrawerComponent;
